
import useApplications from '../../hooks/useApplication';
import { add } from '../../validations/applicationValidation';
import defaultAppIcon from '../../assets/images/icons/default_app_icon.png';

const Application = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const { applicationsData, setApplicationsData, isLoading, applicationsError, deleteApplication, initialValues, setInitialValues, fetchApplication, createOrUpdateApp } = useApplications();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedApplicationId, setSelectedApplicationId] = useState(null);
    const [show, setShow] = useState(false);
    const [preview, setPreview] = useState(null);
    const [search, setSearch] = useState("");
    const [deleteImage, setDeleteImage] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const handleClose = () => {
        setShow(false);
    };
    const handleSubmit = (values, { setSubmitting }) => {
        try {
            console.log(values)
            const formData = new FormData();
            formData.append('app_name', values.app_name);
            formData.append('description', values.description);
            formData.append('application_icon', values.application_icon);
            if (selectedApplicationId) {
                formData.append('delete_image', deleteImage);
            }
            createOrUpdateApp(selectedApplicationId, formData);
            setSubmitting(false);
            setShow(false);
            setDeleteImage(false);
        } catch (error) {
            setSubmitting(false);
            // Handle error
        }
    };

    const handleAddNewButtonClick = () => {
        setInitialValues({
            app_name: "",
            description: "",
            application_icon: null,
        }); setShow(true);
        setPreview(null);
        setSelectedApplicationId(null);
    };

    const handleDeleteButtonClick = (applicationId) => {
        setSelectedApplicationId(applicationId);
        setShowDeleteModal(true);
    };

    const handleShowModal = async (applicationId) => {
        try {
            const application = await fetchApplication(applicationId);
            const iconSrc = application.application_icon && !application.application_icon.startsWith('http')
                ? `${BASE_URL}${application.application_icon}`
                : application.application_icon || defaultAppIcon;
            setPreview(iconSrc);
            setSelectedApplicationId(applicationId);
            setShow(true);
        } catch (error) {
            // Handle error
        }
    };


    const handleConfirmDelete = async () => {
        await deleteApplication(selectedApplicationId);
        setShowDeleteModal(false);
        toast.success('Application deleted successfully');
    };

    const handleDeleteImage = () => {
        setPreview(null);
        { !selectedApplicationId ? setDeleteImage(false) : setDeleteImage(true) }
    };

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        const result = applicationsData.filter((application) => {
            return application.app_name.toLowerCase().match(search.toLowerCase());
        });
        setApplicationsData(result);
    }, [search]);

    Fancybox.bind('[data-fancybox="gallery"]', {
        // groupAll: false // Disable carousel by not grouping all images
        groupAttr: false
    }
    );


    const columns = [
        { name: 'ID', selector: row => row.serial, sortable: true, width: '60px' },
        {
            name: 'Application Icon',
            cell: row => {
                const iconSrc = row.application_icon && !row.application_icon.startsWith('http')
                    ? `${BASE_URL}${row.application_icon}`
                    : row.application_icon || defaultAppIcon;
                return (
                    <a data-fancybox="gallery" href={iconSrc}>
                        <img src={iconSrc}
                            alt={iconSrc}
                            style={{ width: 50, height: 50 }} />
                    </a>
                );
            }
        },
        { name: 'Application Name', selector: row => row.app_name, sortable: true, width: '170px' },
        { name: 'Description', selector: row => row.description, sortable: true },
        {
            name: 'Actions',
            cell: row => (
                <div className="action-group">
                    <Button variant="warning" onClick={() => handleShowModal(row.id)}>
                        <FaPencilAlt/> 
                    </Button>
                    <Button variant="danger" onClick={() => handleDeleteButtonClick(row.id)} >
                        <FaTrash/>
                    </Button>
                </div>
            )
        }
    ];

    return (
        <Layout>

            <div className="page-header">
                <div className="page-header-left">
                    <h1 className="page-title">Applications</h1>
                </div>
                <div className="page-header-right">
                    <Button variant="primary" onClick={handleAddNewButtonClick}>
                        <span className="me-1">
                            <FaPlus style={{ color: "white" }} />
                        </span>
                        Add New</Button>
                </div>

            </div>
<div className="container-fluid">
        <div className="px-3">
            {isLoading && <div>Loading...</div>}

            {applicationsError && <div>Error: {applicationsError}
            </div>}
            {!isLoading && !applicationsError && (
                <DataTable
                    columns={columns}
                    data={applicationsData}
                    fixedHeader
                    pagination
                    highlightOnHover
                    subHeader
                    subHeaderComponent={
                        <input
                            type="text"
                            className="w-25 mt-3 form-control"
                            placeholder="Search Application"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    }

                />

            )}
</div></div>
            <DynamicModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                title="Confirm Deletion"
                body="Do you want to delete this application permanently?"
                primaryButtonText="Yes"
                secondaryButtonText="No"
                onPrimaryButtonClick={handleConfirmDelete}
                onSecondaryButtonClick={() => setShowDeleteModal(false)}
            />
            <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {!selectedApplicationId ? "Add Application" : "Edit Application"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={add}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, errors, touched, values, handleChange, setFieldValue, response_data }) => (
                            <Form>
                                <Row>
                                    <Col md={12}>

                                        <BootstrapForm.Group className="mb-3">
                                            <BootstrapForm.Label>Application Name</BootstrapForm.Label>
                                            <Field
                                                name="app_name"
                                                type="text"
                                                className={`form-control ${touched.app_name && errors.app_name ? 'is-invalid' : ''}`}
                                            />
                                            {touched.app_name && errors.app_name && (
                                                <div className="invalid-feedback">{errors.app_name}</div>
                                            )}
                                        </BootstrapForm.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <BootstrapForm.Group className="mb-3">
                                            <BootstrapForm.Label>Description</BootstrapForm.Label>
                                            <Field
                                                name="description"
                                                type="text"
                                                className={`form-control ${touched.description && errors.description ? 'is-invalid' : ''}`}
                                            />
                                            {touched.description && errors.description && (
                                                <div className="invalid-feedback">{errors.description}</div>
                                            )}
                                        </BootstrapForm.Group>
                                    </Col>
                                </Row>
                                <Col md={12}>
                                    <BootstrapForm.Group>
                                        <BootstrapForm.Label>Logo</BootstrapForm.Label>
                                        <input name="application_icon" className="form-control" type="file" onChange={(event) => {
                                            setFieldValue(`application_icon`, event.target.files[0]);
                                            const reader = new FileReader();
                                            setDeleteImage(false);
                                            reader.onloadend = () => {
                                                setPreview(reader.result);
                                            };
                                            reader.readAsDataURL(event.target.files[0]);

                                        }} />
                                        {preview && (<>

                                            <div>
                                                <Row className="mt-3">
                                                    <div className="position-relative">
                                                        <Image height="50%" width="50%" src={preview} thumbnail />

                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="position-absolute top-0 end-5"
                                                            onClick={() => handleDeleteImage()}
                                                            style={{ zIndex: 1 }}
                                                        >
                                                            {!selectedApplicationId ? 'X'
                                                                : <FaTrash />}

                                                        </Button>
                                                    </div>
                                                </Row>
                                            </div>


                                        </>)

                                        }

                                    </BootstrapForm.Group>
                                </Col>

                                <Modal.Footer>
                                    <Button variant="danger" onClick={handleClose}>
                                        Close
                                    </Button>
                                    <Button variant="primary" type="submit" >
                                        {!selectedApplicationId ? "Save" : "Update"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </Layout>
    );
};

export default Application;
